// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qSnD","footer":"styles_footer__1W-A7","passCodeTooltip":"styles_passCodeTooltip__3wCEu"};